<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6"
                 :lg="7"
                 :md="8"
                 :sm="24">
            <a-form-model-item :label="language['gift_user_app']"
                               :labelCol="labelCol">
              <a-select v-model="queryParam.appCode"
                        :placeholder="language['common.pleaseChoose'] + language['gift_user_app']"
                       :disabled='appLimit.limit'>
                <a-select-option v-for="(value, key) in appLimit.appCodeNameMap" :key="key" :value="key">
                  {{ value }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :xl="8" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'gift:qa:insert'">{{language['common.insertButton']}}</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('Q&A')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" v-has="'gift:qa:delete'"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="false"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'gift:qa:edit'">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-has="'gift:qa:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <template slot='content'  slot-scope='text'>
          <div class='slot-content' :title='text'>
            <a-span >{{text}}</a-span>
          </div>
        </template>

        <template slot='appName'  slot-scope='text'>
          <div :title='text'>
            <a-span >{{appLimit.appCodeNameMap[text]}}</a-span>
          </div>
        </template>

      </a-table>
    </div>

    <qa-modal ref="modalForm" @ok="modalFormOk" :app-limit='appLimit'></qa-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import QaModal from './modules/QaModal'
  import { getAction } from '../../../../api/manage'
  import appList from '../event/AppList'

  export default {
    name: 'QaList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      QaModal
    },
    data () {
      const language = this.$store.getters.language;
      return {
        disableMixinCreated: true,
        description: 'Q&A管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title: language['gift_user_app'],
            align:"center",
            dataIndex: 'appCode',
            width: 200,
            scopedSlots: { customRender: 'appName' },
          },
          {
            title:language['category'],
            align:"center",
            dataIndex: 'category',
            width: 200,
          },
          {
            title:language['gift.qa.q'],
            align:"center",
            dataIndex: 'question',
            width: 450,
            scopedSlots: { customRender: 'content' },
          },
          {
            title:language['gift.qa.a'],
            align:"center",
            dataIndex: 'answer',
            width: 465,
            scopedSlots: { customRender: 'content' },
          },
          {
            title: language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/gift/qas",
          delete: "/gift/qa",
          deleteBatch: "/gift/qa/batch",
          exportXlsUrl: "/gift/export-xls",
          importExcelUrl: "gift/import-excel",
          appLimitData: "/gift/app/appLimitData",
        },
        dictOptions:{},
        superFieldList:[],
        appLimit:{
          limit:false,
          appCodeNameMap:[],
          activeAppCode: undefined,
        },
        queryParam:{
          appCode : undefined,
        }
      }
    },
    created() {
       this.getAppLimitData();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      language() {
        return this.$store.getters.language
      },
    },
    methods: {
      async getAppLimitData(){
        await getAction(this.url.appLimitData).then(res=>{
          this.appLimit = res.result;
          if (res.result.limit){
             this.appLimit.limit = true;
             this.queryParam.appCode = res.result.activeAppCode;
             this.$forceUpdate();
          }
        });
        this.loadData(1);
      },
      searchReset(){
        if (!this.appLimit.limit){
          this.this.queryParam.appCode = undefined;
        }
      }
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
.slot-content{
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  width: 432px;
}

</style>
